module.exports = __webpack_public_path__ + "img/box6_icon6.aa341fc7.jpg";